export class ProjectPasswordService implements IService {
  private readonly ItemResource;
  private notificationService: any;

  constructor(rootScope: IRootScope, $resource: any, configService: any, resourceWrapperService: any, tokenService: any, httpService: any, notificationService: any) {
    this.notificationService = notificationService;
    const projectPasswordResource = $resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/password/:id`,
      {"id": "@id", "projectId": "@projectId"},
      {"update": {method: "PUT"}});

    this.ItemResource = resourceWrapperService.WrapActions(projectPasswordResource);
  }

  public static async Save(newProjectPassword: any) {
    return (newProjectPassword as any).$save();
  }

  public async FindOne(id: string, projectId: string) {
    return this.ItemResource.get({id: id, projectId: projectId});
  }

  public async FindAll(projectId: string) {
    return this.ItemResource.query({projectId: projectId});
  }

  public Create(projectId: string, password: string) {
    return new this.ItemResource({projectId, password});
  }

  public Delete(password, callback?: Function, errorCallback?: Function) {
    password.$delete((response, deleteResponseHeaders) => callback?.call(this, response), () => {
      this.notificationService.addError({
        title: "Error deleting password",
        description: "That's embarrassing, please try again later",
        timeout: 5000
      });

      errorCallback?.call(this);
    });
  }
}

frontendApp.factory("ProjectPasswordService", ['$rootScope', '$resource', 'ConfigService', 'ResourceWrapperService', 'TokenService', 'HttpService', 'NotificationService', function(rootScope, resource, configService, resourceWrapperService, tokenService, httpService, notificationService) {
  return new ProjectPasswordService(rootScope, resource, configService, resourceWrapperService, tokenService, httpService, notificationService);
}]);
